module.exports = __webpack_public_path__ + "img/sync-goods-hei.dd22feb8.svg";